<template>
<div >

    <component :is="layout">
    </component>
</div>
</template>



<script>
import Vue from 'vue';
import router from "./router";
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import ForgetLayout from './layouts/ForgetLayout';
import LockLayout from './layouts/LockLayout';
import ErrorLayout from './layouts/ErrorLayout';

export default{


computed: {

layout(){
    return (this.$route.meta.layout || 'main')+'-layout';
},


},

components: {
    MainLayout,
    AuthLayout,
    ForgetLayout,
    LockLayout,
    ErrorLayout,

},






}
</script>
